import type { EdutainmentApplication } from '../../types';

export const HISTORY_APPLICATIONS: EdutainmentApplication[] = [
  {
    _id: '007',
    name: '太極拳基礎班',
    plans: ['金卡會員', '白金卡會員'],
    category: '運動',
    reviewDeadline: 1642249600001,
    autoReleaseDate: 1642336000001,
    status: '已結束',
    currentEnrollment: 12,
    minimumEnrollment: 10,
    startDate: 1643198400001,
    endDate: 1648923200001,
    times: ['星期二08:00~09:30', '星期四08:00~09:30'],
    teacher: '王太極',
    administrator: '林主任',
  },
  {
    _id: '008',
    name: '油畫創作班',
    plans: ['金卡會員', '白金卡會員', '鑽卡會員'],
    category: '藝術',
    reviewDeadline: 1753459200001,
    autoReleaseDate: 1753545600001,
    status: '審核逾期',
    currentEnrollment: 0,
    minimumEnrollment: 8,
    startDate: 1761408000001,
    endDate: 1777132800001,
    times: ['星期一14:00~16:00', '星期四14:00~16:00'],
    teacher: '張油畫',
    administrator: '陳主任',
  },
  {
    _id: '009',
    name: '爵士鼓入門班',
    plans: ['銀卡會員', '金卡會員', '白金卡會員'],
    category: '音樂',
    reviewDeadline: 1754668800001,
    autoReleaseDate: 1754755200001,
    status: '審核未通過',
    currentEnrollment: 0,
    minimumEnrollment: 5,
    startDate: 1762617600001,
    endDate: 1778342400001,
    times: ['星期三20:00~21:30', '星期五20:00~21:30'],
    teacher: '李爵士',
    administrator: '王主任',
  },
  {
    _id: '010',
    name: '義式料理班',
    plans: ['金卡會員', '白金卡會員'],
    category: '烹飪',
    reviewDeadline: 1755878400001,
    autoReleaseDate: 1755964800001,
    status: '未開成',
    currentEnrollment: 8,
    minimumEnrollment: 12,
    startDate: 1763827200001,
    endDate: 1779552000001,
    times: ['星期二16:00~18:00', '星期五16:00~18:00'],
    teacher: 'Marco',
    administrator: '吳主任',
  },
  {
    _id: '011',
    name: '日語會話班',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員'],
    category: '語言',
    reviewDeadline: 1757088000001,
    autoReleaseDate: 1757174400001,
    status: '未開成',
    currentEnrollment: 2,
    minimumEnrollment: 8,
    startDate: 1765036800001,
    endDate: 1780761600001,
    times: ['星期二18:00~19:30', '星期四18:00~19:30'],
    teacher: '山田老師',
    administrator: '李主任',
  },
  {
    _id: '012',
    name: '陶藝製作班',
    plans: ['金卡會員', '鑽卡會員', '白金卡會員'],
    category: '技藝',
    reviewDeadline: 1758297600001,
    autoReleaseDate: 1758384000001,
    status: '未開成',
    currentEnrollment: 3,
    minimumEnrollment: 6,
    startDate: 1766246400001,
    endDate: 1781971200001,
    times: ['星期一10:00~12:00', '星期四10:00~12:00'],
    teacher: '黃陶藝',
    administrator: '張主任',
  },
];
